import { format, parseISO } from "date-fns";

export default function getDayOfMonth(dateTimeString) {
  if (!dateTimeString) return null;
  const date = parseISO(dateTimeString);
  const dayOfMonth = format(date, "d");
  return dayOfMonth;
}
